import Reading from './Reading'

export default class ReadingFalls extends Reading {

	constructor (data) {
		super(data)
		if (data) {
			this.values.false_positive = this.values.false_fall
			delete this.values.false_fall
		}
	}
}



// WEBPACK FOOTER //
// ./src/classes/ReadingFalls.js